import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/florida-driving-test.jpg";
import cardImage from "../../assets/images/pages/cursos-en-espanol/driver-licence-1.jpg";
import "./FourHourBDI.css";

const ExamenPracticoDeLicencia = () => {
    const locations = [
        {
            title: "Miami-Dade Road Test Location",
            subtitle: "Serves Central FIU-Dade Area",
            address: ["1321 SW 107 Avenue, 2nd Floor, #213A", "Miami, FL 33174"],
            directionsLink: "https://www.mapquest.com/us/florida/miami/33174-2521/1321-sw-107th-ave-25.75653,-80.36661",
            registerLink: "https://classroom.metrotrafficschool.com/road-exam/registration/MTg=/MQ==",
        },
        {
            title: "Miami-Dade Road Test Location",
            subtitle: "Serves N. Dade & S. Broward Area",
            address: ["180 NW 183 Street, #113", "Miami, FL 33169"],
            directionsLink: "https://www.mapquest.com/us/florida/miami/33169/nw-183rd-st-25.9426,-80.20156",
            registerLink: "https://classroom.metrotrafficschool.com/road-exam/registration/MTg=/NA==",
        },
        {
            title: "Broward Road Test Location",
            subtitle: "Serves all of Broward",
            address: ["3726 W. Oakland Park Blvd,", "Lauderdale Lakes, FL 33311"],
            directionsLink: "https://www.mapquest.com/us/florida/lauderdale-lakes/33311-1151/3726-w-oakland-park-blvd-26.16461,-80.19931",
            registerLink: "https://classroom.metrotrafficschool.com/road-exam/registration/MTg=/Mg==",
        },
        {
            title: "Palm Beach County Test Location",
            subtitle: "Serves all of Palm Beach",
            address: ["1993 S. Military Trail,", "West Palm Beach, FL 33415"],
            directionsLink: "https://www.mapquest.com/us/florida/west-palm-beach/33415-6405/1993-s-military-trl-26.64827,-80.11339",
            registerLink: "https://classroom.metrotrafficschool.com/road-exam/registration/MTg=/Mw==",
        },
    ];

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Prueba de manejo de la licencia de conducir,</h1>
                            <p className="banner-subheading">También conocida como prueba de habilidades</p>
                        </div>
                    </div>
                </div>
            </section >


            <main className="bdi-page mb-3">
                <div className="container mt-5">
                    <div className="row mb-5">
                        <div className="col-12">
                            <ShellCard>
                                <div className="row">
                                    <div className="col-12 col-lg-6 mb-4">
                                        <img src={cardImage} alt="Driving Test" className="img-fluid rounded shadow" />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <p className="mb-3">
                                            Metro ofrece la prueba de manejo práctica del DMV. No espere semanas para obtener una cita en el DMV, simplemente llame al número que se encuentra en la parte inferior de la página para comenzar. Una vez inscrito, podrá completar rápidamente la prueba de habilidades para obtener su licencia de conducir regular de clase E.
                                        </p>
                                        <h5 className="fw-bold text-warning mb-3">Beneficios de tomar el examen de manejo del DMV con Metro:</h5>
                                        <ul className="mb-4">
                                            <li>Entrar y salir rápidamente</li>
                                            <li>Utilice nuestro coche de doble control</li>
                                            <li>Ambiente de baja presión</li>
                                            <li>Informe inmediato al DMV: recoja la licencia tan pronto como apruebe el examen de manejo</li>
                                            <li>Ofrecido en nuestra localidad frente a la universidad FIU</li>
                                            <li>Reciba un descuento en el examen de manejo si también compra cualquier otro curso relacionado con Metro</li>
                                        </ul>

                                        <h5 className="text-uppercase mb-2">EL PRECIO DE LA PRUEBA INCLUYENDO EL USO DE NUESTRO AUTO ES DE <span className="fw-bold text-warning">$100.00</span></h5>
                                        <p className="fw-bold text-uppercase mb-2">PARA INSCRIBIRSE POR FAVOR LLÁMENOS AL <a href="tel:3055130063" className="text-decoration-none text-warning">(305) 513-0063</a> - <a href="tel:188841METRO" className="text-decoration-none text-warning">1-888-41-METRO</a></p>
                                        <p className="small text-muted">* Todos los que completan la prueba del DMV fuera de la oficina del DMV, están sujetos a un nuevo examen al azar.</p>
                                    </div>
                                </div>
                            </ShellCard>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 text-center mb-4">
                            <h2 className="fw-bold text-warning">Metro Road Exam Sites</h2>
                        </div>
                        {locations.map((loc, index) => (
                            <div key={index} className="col-12 col-md-6 col-lg-3 mb-4">
                                <div className="card h-100 border-0 shadow-sm">
                                    <div className="card-body d-flex flex-column">
                                        <h5 className="card-title fw-bold">{loc.title}</h5>
                                        <p className="card-text text-muted mb-3">{loc.subtitle}</p>
                                        <div className="mb-auto">
                                            {loc.address.map((line, i) => (
                                                <p key={i} className="card-text mb-0 fst-italic">{line}</p>
                                            ))}
                                        </div>
                                        <div className="mt-3">
                                            <a href={loc.directionsLink} target="_blank" rel="noopener noreferrer" className="text-decoration-none d-block mb-2">Directions</a>
                                            <a href={loc.registerLink} target="_blank" rel="noopener noreferrer" className="btn metro-btn-primary w-100 fw-bold text-uppercase">Register Now!</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </>
    );
};

export default ExamenPracticoDeLicencia;
